//DaysettingUtils.js
//date handling
import moment from 'moment';
//Shared utilities for daysettings
export default function utils () {
	var model = {
		daysetting : {
			radarpower : [],
			auxpower : [],
			power : [],
			speed : {
				default : 25,
				intervals : []
			},
			threshold : {
				default : 25,
				intervals : []
			},
			op : {
				default : 1,
				intervals : []
			},
			maxspeed : {
				default : 99,
				intervals : []
			},
			dim : [
				{
					time : '00:00:00',
					value : 99
				}
			]
		},
		settingGroup : {
			speed: 25,
			op : 7,
			maxspeed: 35,
			threshold: 25,
			intervals : []
		},
		days : [
			//'sunday',
			'monday',
			'tuesday',
			'wednesday',
			'thursday',
			'friday',
			'saturday',
			'sunday'
		],
		settingList : [
			'speed',
			'threshold',
			'op',
			'maxspeed'
		],
		powers : [
			{
				type : 'power',
				label : 'Display power'
			},
			{
				type : 'radarpower',
				label : 'Radar power'
			},
			{
				type : 'auxpower',
				label : 'Modem power'
			}
		]
	};
		
	var control = {
		interval : {
			//Inserts the interval in order
			insert : (interval, intervals) => {
				//Add interval
				intervals.push(interval);
				//flatten
				var iflat = intervals.flat();
				//sort the flat version
				iflat.sort();
				//regroup
				intervals = [];
				while(iflat.length > 0){
					intervals.push([iflat.shift(), iflat.shift()]);
				}
				//interval = control.interval.order(interval);
				//if(intervals.length > 0){
				//	intervals.splice(control.interval.position(interval, intervals), 0, interval);
				//} else {
				//	intervals = [interval];
				//}
				return intervals;
			},
			//gets the appropriate insert position for the interval
			position : (interval, intervals) => {
				for(var n in intervals){
					if(control.time.compare(interval[0], intervals[n][0]) < 1){
						return n;
					}
				}
				return intervals.length;
			},
			//Sorts intervals
			sort : (intervals) => {
				
			},
			//puts the two times of the interval in order
			order : (interval) => {
				return control.time.compare(interval[0], interval[1]) > 0 ? [interval[1], interval[0]] : interval;
			},
			//checks if the interval conflicts with any of the exising intervals
			validate : (interval, intervals) => {
				//console.log(interval);
				//console.log(intervals);
				interval = control.interval.order(interval);
				if(intervals.length > 0){
					if(control.interval.isInIntervals(interval[0], intervals)){
						return false;
					}
					if(control.interval.isInIntervals(interval[1], intervals)){
						return false;
					}
					if(control.interval.isIntervalsIn(interval, intervals)){
						return false;
					}
				}
				return true;
			},
			//is any interval in the interval
			isIntervalsIn : (interval, intervals) => {
				for(var n in intervals){
					if(control.interval.isIn(intervals[n], interval)){
						return true;
					}
				}
				return false;
			},
			//is the time between any interval in intervals?
			isInIntervals : (time, intervals) => {
				for(var n in intervals){
					if(control.interval.isIn(time, intervals[n])){
						return true;
					}
				}
				return false;
			},
			//is the time between the interval?
			isIn : (time, interval) => {
				//does it come after start?
				if(control.time.compare(time, interval[0]) >= 0){
					if(control.time.compare(time, interval[1]) <= 0){
						return true;
					}
				}
				return false;
			}
			
		},
		setting : {
			checkMatch : (curset, altset) => {
				for(var n in model.settingList){
					if(curset[model.settingList[n]] !== altset[model.settingList[n]]){
						return false;
					}
				}
				return true;
			},
			insert : (setting, settings) => {
				let i = 0;
				settings.forEach((val) => {
					if(control.time.compare(setting.time, val.time) > 0){
						i++;
					} else {
						return;
					}
				});
				//console.log("inserting at position "+i);
				settings.splice(i, 0, setting);
				return settings;
			},
			//compiles settings from intervals
			compile: (settings, groups) => {
				//remove intervals from settings
				model.settingList.forEach((setting) => {
					settings[setting].intervals = [];
				});
				//extract the groups to flatten as intervals only
				let intervals = [];
				//these will be flattened and sorted to insert in order
				let keytimes = [];
				//compile new intervals for each
				groups.forEach((group) => {
					group.intervals.forEach((times) => {
						keytimes.push(times[0], times[1]);
						let interval = {
							on: times[0],
							off: times[1]
						};
						model.settingList.forEach((setting) => {
							interval[setting] = group[setting];
						});
						intervals.push(interval);
					});
				});
				//sort all the times
				keytimes.sort();
				//iterate all times to insert intervals in order
				keytimes.forEach((time) => {
					let idx = intervals.findIndex((interval) => {return interval.on === time});
					if(idx !== -1){
						model.settingList.forEach((setting) => {
							settings[setting].intervals.push({
								value: intervals[idx][setting],
								on: intervals[idx].on,
								off: intervals[idx].off
							});
						});
					}
				});
				return settings;
			},
			//get the setting with the most intervals
			maxIntervals : (settings) => {
				return model.settingList.reduce((mostintervals, setting) => {
					if(settings[setting].intervals.length > settings[mostintervals].intervals.length)
						return setting;
					return mostintervals;
				}, 'threshold');
			},
			//get the on/off times for all intervals
			flatIntervalTimes : (settings) => {
				let maxer = control.setting.maxIntervals(settings);
				return settings[maxer].intervals.reduce((a, v) => [...a, v.on, v.off], []);
			},
			//new version of extract intervals
			extractIntervals : (settings) => {
				//get the setting with the most intervals
				var useset = control.setting.maxIntervals(settings);
				//compile intervals for each setting per the largest interval set
				return settings[useset].intervals.reduce((csets, interval, i) => {
					//compile interval for each setting
					let cinterval = model.settingList.reduce((cset, setting, s) => {
						//check if setting has an interval value
						if(settings[setting].intervals[i] !== null 
						&& settings[setting].intervals[i] !== undefined){
							cset[setting] = settings[setting].intervals[i].value;
						} else {
							cset[setting] = settings[setting].default;
						}
						return cset;
					}, {});
					//always add the first interval
					if(i === 0){
						cinterval.interval = interval.on+' - '+interval.off;
						cinterval.intervals = [[interval.on, interval.off]];
						csets.push(cinterval);
					} else {
						//check if any other interval has matching settings
						let matched = csets.findIndex(itv => control.setting.checkMatch(cinterval, itv));
						if(matched === -1){
							//none found, add it as a new one
							cinterval.intervals = [[interval.on, interval.off]];
							csets.push(cinterval);
						} else {
							//add interval to existing setting group
							csets[matched].intervals.push([interval.on, interval.off]);
						}
					}
					return csets;
				}, []);
			},
			
			//extracts intervals from settings
			extractIntervalsOld : (settings) => {
				var csets = [];
				var didfirst = false;
				var eachSetting = model.settingList;
				//iterate intervals of threshold - most likely to have the most
				for(var n in settings.threshold.intervals){
					//zero out placeholder for setting group
					let cset = {};
					//Iterate each setting intervals - expected match with threshold
					for(var x in eachSetting){
						//verify that other settings have an interval value
						if(settings[eachSetting[x]].intervals[n] !== null 
				  		&& settings[eachSetting[x]].intervals[n] !== undefined){
							//console.log('Interval '+n+' exists for '+eachSetting[x]+' and is '+settings[eachSetting[x]].intervals[n].value);
							cset[eachSetting[x]] = settings[eachSetting[x]].intervals[n].value;
						} else if(cset[eachSetting[x]] === null || cset[eachSetting[x]] === undefined){
							//console.log('Did not find interval '+n+' in '+eachSetting[x]+' setting populating with '+settings[eachSetting[x]].default);
							//if no setting exists, use the default
							cset[eachSetting[x]] = settings[eachSetting[x]].default;
						}
						
					}
					if(!didfirst){
						//always add the first interval
						cset.interval = settings.threshold.intervals[n].on+' - '+settings.threshold.intervals[n].off;
						cset.intervals = [[settings.threshold.intervals[n].on, settings.threshold.intervals[n].off]];
						csets.push(cset);
						//console.log('Added the first interval');
						//console.log(cset);
					} else {
						//check for matches and append interval to existing match
						var copied = false;
						for(var y in csets){
							if(control.setting.checkMatch(cset, csets[y])){
								//console.log('The following two setting groups are the same');
								//console.log(cset);
								//console.log(csets[y]);
								//add interval to matching set
								csets[y].intervals.push([settings.threshold.intervals[n].on, settings.threshold.intervals[n].off]);
								copied = true;
								break;
							}
						}
						//if no matches, append full settings with interval
						if(!copied){
							//console.log('no matching setting groups found for:');
							//console.log(cset);
							//found no suitable matches to add to
							cset.intervals = [[settings.threshold.intervals[n].on, settings.threshold.intervals[n].off]];
							csets.push(cset);
						}
					}
					didfirst = true;
				}
				//console.log("Original daysettings");
				//console.log(settings);
				//console.log("Extracted Intervals");
				//console.log(csets);
				return csets;
			},
			//compile a description from settings
			description : (settings) => {
				//first, get the intervals
				var description = 'Mode '+settings.op.default+', limit '+settings.speed.default;
				var intervals = control.setting.extractIntervals(settings);
				if(intervals.length > 0){
					let interval = intervals.shift();
					let init = interval.intervals.shift();
					description+=' and mode '+interval.op+', limit '+interval.speed+' from '+
						interval.intervals.reduce((prev, cur) => 
							prev+' and '+control.time.pretty(cur[0])+' - '+control.time.pretty(cur[1]), control.time.pretty(init[0])+' - '+control.time.pretty(init[1]));
					while(intervals.length > 0){
						interval = intervals.shift();
						init = interval.intervals.shift();
						description+=' then mode '+interval.op+', limit '+interval.speed+' from '+
							interval.intervals.reduce((prev, cur) => 
								prev+' and '+control.time.pretty(cur[0])+' - '+control.time.pretty(cur[1]),
								control.time.pretty(init[0])+' - '+control.time.pretty(init[1]));
					}
					
				}
				return description;
			},
			name : (days) => {
				//All 7 days
				if(days.length === 7){
					return 'Everyday';
				}
				//Weekends
				if(days.length === 2 
				   && days.indexOf('sunday') !== -1 
				   && days.indexOf('saturday') !== -1){
					return 'Weekends';
				}
				//Weekdays
				if(days.length === 5 
				  && days.indexOf('sunday') === -1
				  && days.indexOf('saturday') === -1){
					return 'Weekdays';
				}
				//Otherwise all days concatenated
				return days.map(d => d[0].toUpperCase()+d.substring(1)).join(', ');
			}
		},
		time : {
			fromString : (ts) => {
				var [hours, minutes, seconds] = Array.from(ts.split(':'), x => parseInt(x));
				if(minutes === undefined 
				   || minutes === false 
				   || minutes === null){
					minutes = 0;
				}
				if(seconds === undefined
				  || seconds === false 
				  || seconds === null){
					seconds = 0;
				}
				return [hours, minutes, seconds];
			},
			insert : (time, times)=> {
				
				
			},
			toString : (hours, minutes, seconds) => {
				return control.time.pad(hours)+':'+control.time.pad(minutes)+':'+control.time.pad(seconds);
			},
			toSeconds : (timeString) => {
				//convert time to seconds of the day
				var seconds = 0;
				control.time.fromString(timeString).forEach((t, i) => seconds+=t * Math.pow(60, i));
				return seconds;
			},
			compare : (atime, btime) => {
				//is atime higher, lower, or equal to btime 1, -1, 0
				var asec = control.time.toSeconds(atime);
				var bsec = control.time.toSeconds(btime);
				if(asec > bsec){
					return +1;
				} else if(asec < bsec){
					return -1;
				} else {
					return 0;
				}
			},
			pad : (hms) => {
				return parseInt(hms) < 10 ? '0'+hms : hms;
			},
			pretty : (ts) => {
				var [hours, minutes, seconds] = control.time.fromString(ts);
				if(hours === 0){
					hours = 24;
				}
				var dp = 'pm';
				if(seconds > 58){
					seconds = 0;
					minutes++;
				}
				if(minutes > 58){
					minutes = 0;
					hours++;
				}
				if(hours % 12 === 0){
					if(hours > 12){
						dp = 'am';
						hours = 12;
					}
				} else if(hours < 12){
					dp = 'am';
				} else if(hours > 12){
					hours-=12;
				}
				if(seconds === 0){
					if(minutes === 0){
						return hours+dp;
					}
					return hours+':'+control.time.pad(minutes)+dp;
				}
				return hours+':'+control.time.pad(minutes)+':'+control.time.pad(seconds)+dp;
			}
		},
		date : {
			human : (date) => {
				// var mdate = moment(date);
				 var hdate = moment(date).calendar().split(' at')[0];
				 if(!hdate.includes('/')){
					 return hdate;
				 }
		 
				 let [year, month, day] = date.split('-').map(d => parseInt(d));
				 if(year !== (new Date()).getFullYear()) return hdate;
				 return [month, day].join('/');
			 }
		}
	}
	return {
		model : model,
		control : control
	};
}